/**
 * Created by Ivan on 01.08.2026
 */

Placements.ENTRIES["balloonRiseLose"] = {
    type: Placements.FREE_FOCUS,

    filter: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_BALLOON_RISE);
        return mission && mission.logic.needShowLoseWindow;
    },

    action: function () {
        const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_BALLOON_RISE);
        mission.logic.showLoseWindow();
    }
};
